// @ts-strict-ignore
import {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {CohortGroupEntry} from 'common/query-builder/query-entry-section/types';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';

// eslint-disable-next-line import/no-cycle
import {CohortGroupEntryRow} from './index';

export const helpers: EntryRowTypeHelpers<CohortGroupEntry> = {
  component: CohortGroupEntryRow,
  isPlaceholder({entry}) {
    return !entry.filters.every((filter) => new PropertyFilter(filter).isValid());
  },
  isIntermediatePlaceholder(row) {
    const isPlaceholder = this.isPlaceholder(row);

    return isPlaceholder && !!row.entry.event;
  },
};
